import React from 'react';
import { Sparkles } from 'lucide-react';
import { SectionDivider } from './SectionDivider';
export function PoweredBySection() {
  return <section className="py-12 px-4 md:px-6" style={{
    backgroundColor: '#050505'
  }} data-id="element-447">
      <div className="max-w-4xl mx-auto text-center reveal" data-id="element-448">
        <div className="inline-flex items-center justify-center p-3 bg-gradient-to-br from-[#c9a84c]/20 to-transparent rounded-xl mb-6 border border-[#c9a84c]/30" data-id="element-449">
          <Sparkles className="w-8 h-8 text-[#c9a84c]" data-id="element-450" />
        </div>
        <h2 className="text-2xl md:text-3xl font-bold text-white mb-4" data-id="element-451">
          Powered by Magic Patterns
        </h2>
        <p className="text-white/70 leading-relaxed text-lg" data-id="element-452">
          We build your site using Magic Patterns, then you can update text,
          images, and sections yourself using AI — with your 100 monthly editing
          requests included.
        </p>
      </div>
      <SectionDivider data-id="element-453" />
    </section>;
}